import { render, staticRenderFns } from "./NotificationCreateForm.vue?vue&type=template&id=a4707766&"
import script from "./NotificationCreateForm.vue?vue&type=script&lang=js&"
export * from "./NotificationCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports